module.exports = __webpack_public_path__ + "media/drop-collect.c354245e.mp3";